<template>
  <main class="campaign-creator campaign-creator-wrapper flex flex-col flex-nowrap">
    <div class="editor-container flex flex-col w-full">
      <CampaignCreatorHeader
        :current-merchant="currentMerchant"
        :stashboard-headers="stashboardHeaders"
        :ownerType="ownerType"
      />

      <stashboard-media-uploader 
        assignedModuleRoute=""
      />


      <editor
        :value="editorValue"
        @update:value="updateValue"
        ref="editor"
        class='border-can-error'
        v-touch:sms_content
        v-has-error:sms_content
      />

      <campaign-action-bar
        class="border-can-error"
        :campaign="campaign"
        :ownerType="ownerType"
        @shouldInsertText="shouldInsertText"
      />
    </div>
  </main>
</template>

<script>
import Editor from "./editor";
import CampaignActionBar from "./action-bar/campaign-action-bar";
import CampaignCreatorHeader from "./campaign-creator-header";
import {mapGetters} from "vuex";
import {HasError, Touch} from "@springbig/sb-components";
import StashboardMediaUploader from "./stashboard-media-uploader/stashboard-media-uploader";
import {stashboardAPI} from "../../services/api/stashboardAPI";

export default {
  name: "campaign-creator",
  directives: {Touch, HasError},
  components: {
    CampaignActionBar,
    Editor,
    StashboardMediaUploader,
    CampaignCreatorHeader
  },

  props: {
    campaign: Object,
    ad: Object,
    ownerType: String,
    message: Object,
    editorValue: String
  },
  data() {
    return {
      stashboardHeaders: [],
    }
  },
  async created() {
    this.stashboardHeaders = await stashboardAPI.getStashboardHeaders();
  },
  methods: {
    updateOrder(item) {
      this.$emit('update:campaign', {stashboard_media_order: item.order || []})
    },
    async updateValue(text) {
      this.$emit("update:editor-value", text);
    },
    async deleteAttachedImage() {
      this.loading = true;
      this.$emit('update:ad', null, this.ad);
      this.loading = false;
    },
    shouldInsertText(text) {
      this.$refs.editor.insertText(text);
    },
  },
  computed: {
    invalidText() {
      return this.$store.getters.hasError('sms_content');
    },
    ...mapGetters(['classicCampaignsEnabled', 'currentMerchant']),
  }
}
</script>

<style scoped>
.campaign-creator {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.editor-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.invalid-text {
  border-color: #f91253;
}

.sb-loading-icon >>> svg {
  fill: #128ff9;
}

.image-container {
  position: relative;
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #A6D4FC;
  border-left: 1px solid #A6D4FC;
}

.image-container button {
  font-family: "AileronThin";
  font-size: 18px;
}

.image-modal >>> header > div {
  position: relative;
}

.image-modal >>> div {
  overflow-y: auto;
}

.image-modal >>> footer {
  margin: 0;
}

.image-modal >>> footer > button {
  position: absolute;
  top: 12px;
  right: 10px;
  line-height: 10px;
  border-radius: 12px;
}

.image-modal >>> .add-image-modal {
  height: auto;
  min-width: 600px;
}

header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  background-color: #A6D4FC;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;

  .logo {
    height: 20px;
    width: auto;
  }
}


@media only screen and (max-width: 1023px) {
  .image-modal >>> .add-image-modal {
    min-width: 350px;
  }

  .image-modal >>> footer > button {
    position: relative;
    top: unset;
    right: unset;
    line-height: unset;
  }
}

</style>
